import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import {
  Navbar,
  Footer,
  PrivacyPolicy,
  TermsnConditions,
  Disclaimer,
  ShippingandDelivery,
  ReturnPolicy,
  Error404,
  Home,
  Aboutus,
} from "./routes/Routes";
import Login from "./routes/auth/Login";
import Dashboard from "./routes/auth/Dashboard";
import { useAuth } from './hooks/GlobalProvider'; // Assuming you have a GlobalProvider for auth
import Renewal from "./routes/auth/Renewal";
import PaymentPage from "./routes/auth/PaymentPage"
import PaymentHistory from "./routes/auth/PaymentHistory"

const App = () => {
  const location = useLocation();
  const { user, loading } = useAuth(); // Assuming useAuth provides user and loading state

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading component
  }

 const hideNavbar = location.pathname === '/login' || location.pathname.startsWith('/dashboard');

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsconditions" element={<TermsnConditions />} />
        <Route path="/returnpolicy" element={<ReturnPolicy />} />
        <Route path="/shippingdelivery" element={<ShippingandDelivery />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/dashboard/renewal" element={user ? <Renewal /> : <Navigate to="/login" />} />
         <Route path="/dashboard/renewal/payment" element={user ? <PaymentPage /> : <Navigate to="/login" />} />
                  <Route path="/dashboard/paymenthistory" element={user ? <PaymentHistory /> : <Navigate to="/login" />} />
        <Route path="/*" element={<Error404 />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
